import React, {useEffect, useRef, useState} from 'react';
import './ToolAmministratoriCondominio.scss';
import {useTranslation} from "react-i18next";
import BillNumberForm from "../../forms/BillNumberForm/BillNumberForm";
import BillData from "../../forms/BillData/BillData";
import WatterBuildingForm from "../../forms/WatterBuildingForm/WatterBuildingForm";
import useResizeObserver from '@react-hook/resize-observer'
import Configuration from "../../../config";

const ToolAmministratoriCondominio = () => {
  const {t} = useTranslation();
  const containerRef = useRef(null);
  const [invoiceInfoData, setInvoiceInfoData] = useState(null)
  const onResize = (entry) => {
    window.top.postMessage({type: 'gcapCaseResize', height: entry.contentRect.height, width: entry.contentRect.width}, Configuration.get('REACT_APP_GCAP_PUBLIC_HOST'));
  }

  useResizeObserver(containerRef, onResize)
  useEffect(() => {
    document.body.classList.add('embed-case');
    return () => {
      document.body.classList.remove('embed-case');
    }
  }, []);
  return (

    <div className={"ToolAmministratoriCondominio"} id={"ToolAmministratoriCondominio"}
         data-testid={"ToolAmministratoriCondominio"} aria-label={"ToolAmministratoriCondominio"}>


      <div className="am-form-container justify-content-center">
        <div className="container">
          <section className="form-container container">
            <div className={'form-content-container'}>
                  <h2 className={'Bollette headline-bold-fs4'}>
                    {t('casses.amministratori_di_condominio.bollette.header')}
                  </h2>
              <BillNumberForm setInvoiceInfoData={setInvoiceInfoData} invoiceData={invoiceInfoData}></BillNumberForm>
            </div>
          </section>
        </div>

        {/*{invoiceInfoData && (*/}
          <>
            <div className="container">
              <section className={"data-container container"}>
                <BillData invoiceInfo={invoiceInfoData}></BillData>
              </section>
            </div>
            <div className="container">
              <section className={"container justify-content-center watter-container"}>
                <WatterBuildingForm amount={invoiceInfoData?.amount} ></WatterBuildingForm>
              </section>
            </div>
          </>

        {/*)}*/}

      </div>


    </div>
  )
}

ToolAmministratoriCondominio.propTypes = {};

export default ToolAmministratoriCondominio;
